import { $api, config } from "..";
import { PageDto } from "../../types/page/page.types";

export const getPage = (pageName: string) => {
    return $api.get<PageDto>(`/pages/${pageName}`, { headers: config()});
}